import { language } from "@chef/constants";

export const intl = (
  {
    no: { CREATE_NEW: "Lag nytt" },
    se: { CREATE_NEW: "Skapa nytt" },
    dk: { CREATE_NEW: "Opret nyt" },
  } as const
)[language];
